import { TUnlockedAchievement } from '../services/server/types';

type AchievementListener = (achievements: TUnlockedAchievement[]) => void;

class AchievementEventBus {
    private listeners: AchievementListener[] = [];

    subscribe(listener: AchievementListener): () => void {
        this.listeners.push(listener);
        
        // Возвращаем функцию для отписки
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    notify(achievements: TUnlockedAchievement[]): void {
        if (achievements && achievements.length > 0) {
            this.listeners.forEach(listener => listener(achievements));
        }
    }
}

export const achievementEvents = new AchievementEventBus();

